/* Source 4: preserve consented paid-click evidence in Shopify cart/order attributes. */
(function () {
  'use strict';
  if (window.S4Attribution) return;
  var KEY = 's4_attribution_v1';
  var ATTRIBUTE = '_s4_attribution';
  var MAX_AGE = 90 * 24 * 60 * 60 * 1000;
  var pending = Promise.resolve();
  var lastSaved = null;
  var memory = null;
  var captured = false;
  var consentAt = null;
  var landing = new URL(window.location.href);
  var now = function () { return new Date().toISOString(); };
  function consent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    return privacy.marketingAllowed() && privacy.analyticsProcessingAllowed()
      && (typeof privacy.saleOfDataAllowed !== 'function' || privacy.saleOfDataAllowed());
  }
  function value(key, limit) {
    var v = landing.searchParams.get(key);
    return v && v.length <= (limit || 256) && !/[<>\x00-\x1f{}]/.test(v) ? v : null;
  }
  function id(keys) {
    for (var k of keys) { var v = value(k, 24); if (v && /^\d+$/.test(v)) return v; }
    return null;
  }
  function read() {
    try { memory = JSON.parse(localStorage.getItem(KEY)) || memory; } catch (_) {}
    if (!memory || memory.v !== 1 || !Array.isArray(memory.touches)) memory = { v: 1, touches: [] };
    memory.touches = memory.touches.filter(function (t) {
      if (!t || !['google', 'microsoft'].includes(t.platform)) return false;
      var age = Date.now() - Date.parse(t.at);
      return age >= -60000 && age < MAX_AGE;
    });
    return memory;
  }
  function capture() {
    if (!consent()) return null;
    var state = read();
    if (!captured) {
      var google = value('gclid') || value('gbraid') || value('wbraid');
      var microsoft = value('msclkid');
      var source = value('utm_source', 80) || '';
      var paid = /^(cpc|ppc|paid|paid_search|paidsearch|display|cpm|paid_social)$/i.test(value('utm_medium', 80) || '');
      var platform = microsoft && !google ? 'microsoft' : google && !microsoft ? 'google'
        : !google && !microsoft && paid && /^(bing|bing_video|microsoft|microsoft_ads)$/i.test(source) ? 'microsoft'
        : !google && !microsoft && paid && /^(google|google_ads|googleads)$/i.test(source) ? 'google' : null;
      if (platform) {
        var touch = {
          platform: platform, at: now(), campaignId: id(['s4_campaign_id', 'campaignid', 'campaign_id', 'utm_id', 'gad_campaignid']),
          adGroupId: id(['s4_adgroup_id', 'adgroupid', 'adgroup_id']), adId: id(['s4_ad_id', 'adid', 'creative']),
          campaign: value('utm_campaign'), source: source || platform, medium: value('utm_medium', 80) || 'cpc',
          gclid: platform === 'google' ? value('gclid') : null, gbraid: platform === 'google' ? value('gbraid') : null,
          wbraid: platform === 'google' ? value('wbraid') : null, msclkid: platform === 'microsoft' ? microsoft : null,
          landingPath: landing.pathname.slice(0, 300)
        };
        var previous = state.touches[state.touches.length - 1];
        if (!previous || ['platform', 'campaignId', 'gclid', 'gbraid', 'wbraid', 'msclkid'].some(function (k) { return previous[k] !== touch[k]; })) state.touches.push(touch);
        // Keep each platform's first and most recent touch within the retention window.
        state.touches = state.touches.filter(function (t, i, all) {
          return all.findIndex(function (x) { return x.platform === t.platform; }) === i
            || !all.slice(i + 1).some(function (x) { return x.platform === t.platform; });
        });
      }
      captured = true;
    }
    if (!state.touches.length) return null;
    consentAt = consentAt || now();
    state.consent = { marketing: true, analytics: true, adUserData: true, at: consentAt };
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
    return JSON.stringify(state);
  }
  function sync() {
    var payload = capture();
    if (!payload || payload.length > 6000) return pending;
    // The consent timestamp is refreshed once per page; serialize cart writes with each other.
    pending = pending.catch(function () {}).then(async function () {
      if (!consent() || lastSaved === payload) return;
      var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [ATTRIBUTE]: payload } })
      });
      if (!response.ok) throw new Error('Attribution cart save failed');
      lastSaved = payload;
    });
    return pending;
  }
  function addFields(form) {
    var payload = capture();
    var action = form.getAttribute('action') || '';
    var name = /\/contact/.test(action) ? 'contact[S4 ad attribution]' : /\/cart/.test(action) ? 'attributes[' + ATTRIBUTE + ']' : null;
    if (!name) return;
    var input = Array.from(form.elements).find(function (el) { return el.name === name; });
    if (!payload) { if (input) input.remove(); return; }
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
    input.value = payload;
  }
  function initialize() {
    sync().catch(function () {});
    document.querySelectorAll('form').forEach(addFields);
  }
  document.addEventListener('submit', function (event) { addFields(event.target); }, true);
  // Normal cart forms carry the attribute in their own submission. Checkout links
  // wait briefly for the cart write without preventing checkout if Shopify is slow.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/checkout\/?$/.test(url.pathname) || !capture()) return;
    event.preventDefault();
    Promise.race([sync().catch(function () {}), new Promise(function (resolve) { setTimeout(resolve, 750); })])
      .then(function () { location.assign(url.href); });
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (consent()) initialize();
    else {
      memory = null; lastSaved = null; consentAt = null; captured = false;
      try { localStorage.removeItem(KEY); } catch (_) {}
      document.querySelectorAll('form').forEach(addFields);
      // Remove previously persisted ad identifiers when the visitor opts out.
      pending = pending.catch(function () {}).then(function () {
        return fetch(((window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [ATTRIBUTE]: '' } })
        });
      }).catch(function () {});
    }
  });
  // Pify quote forms run in a cross-origin iframe and store the page URL they
  // are told about as `submitPageUrl`. Hand them the page URL plus a short
  // `s4_click` code so each submission keeps the consented ad click, and log
  // the click to the dashboard when Pify reports a finished submission.
  var PIFY = /^https:\/\/[a-z0-9-]+\.pifyapp\.com$/;
  function clickCode() {
    var payload = capture();
    if (!payload) return null;
    var touches = JSON.parse(payload).touches || [];
    var code = touches.map(function (t) {
      return [t.platform === 'microsoft' ? 'm' : 'g', t.gclid || t.gbraid || t.wbraid || t.msclkid || '', t.campaignId || '', t.at].join('~');
    }).join('|');
    return code && code.length <= 1200 ? code : null;
  }
  function tagPify(frame) {
    var code = clickCode();
    if (!code || !frame.contentWindow) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('s4_click', code);
      frame.contentWindow.postMessage(JSON.stringify({ parentUrl: url.toString() }), new URL(frame.src).origin);
    } catch (_) {}
  }
  function watchPify() {
    document.querySelectorAll('iframe[id^="form-iframe-"]').forEach(function (frame) {
      if (frame.dataset.s4Tagged) return;
      frame.dataset.s4Tagged = '1';
      // Pify posts its own page URL on load; ours runs after it and wins.
      frame.addEventListener('load', function () { setTimeout(function () { tagPify(frame); }, 50); });
      tagPify(frame);
    });
  }
  window.addEventListener('message', function (event) {
    if (!PIFY.test(event.origin) || typeof event.data !== 'string') return;
    var frame = Array.from(document.querySelectorAll('iframe[id^="form-iframe-"]')).find(function (f) { return f.contentWindow === event.source; });
    if (!frame) return;
    var message = null;
    try { message = JSON.parse(event.data); } catch (_) {}
    if (!message) return;
    if (message.height !== undefined) tagPify(frame);
    if ((message.retsetHeight || message.redirect) && !frame.dataset.s4Logged) {
      var payload = capture();
      if (!payload || !navigator.sendBeacon) return;
      frame.dataset.s4Logged = '1';
      navigator.sendBeacon('https://source4.vercel.app/api/webhooks/shopify/form-capture', JSON.stringify({
        formId: frame.id.replace('form-iframe-', ''), path: window.location.pathname.slice(0, 300), signals: payload
      }));
    }
  });
  var watchQueued = false;
  if (window.MutationObserver) new MutationObserver(function () {
    if (watchQueued) return;
    watchQueued = true;
    setTimeout(function () { watchQueued = false; watchPify(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
  watchPify();

  window.S4Attribution = { sync: sync, version: 1 };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) initialize(); });
})();
